export const DATE_FORMAT_SHORT = 'MM/DD/YYYY'

export const DATE_FORMAT_LONG = 'MM/DD/YYYY HH:mm:ss'
